import { Component, Input } from '@angular/core';
import { CommonModule, NgFor } from '@angular/common';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'skeletor-create-supplier',
  standalone: true,
  imports: [CommonModule, NgFor, SkeletonModule],
  templateUrl: './create-supplier.template.component.html',
  styleUrls: ['./create-supplier.template.component.scss']
})
export class SkeletorCreateSupplierTemplateComponent {
  @Input() items: number = 3;

  get sections(): any[] {
    return Array.from({ length: this.items });
  }

  get fields(): any[] {
    return Array.from({ length: 4 });
  }
}

